import { gql } from "@apollo/client";

export const DISCOUNT_CODES = gql`
  query DiscountCodes(
    $where: DiscountCodeWhereInput
    $like: DiscountCodeWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    discountCodes(
      where: $where
      like: $like
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      data {
        id
        code
        tariffKey
        label
        active
        startDate
        endDate
        process {
          id
          name
        }
      }
      count
    }
  }
`;

export const DISCOUNT_CODE = gql`
  query DiscountCode($where: DiscountCodeWhereInput) {
    discountCode(where: $where) {
      id
      code
      tariffKey
      label
      active
      startDate
      endDate
      process {
        id
        name
      }
    }
  }
`;

export const RESOLVE_PROCESS_DISCOUNT_CODE = gql`
  query ResolveProcessDiscountCode($processId: ID!, $code: String!) {
    resolveProcessDiscountCode(processId: $processId, code: $code) {
      code
      label
    }
  }
`;

const discountCodes = {
  DISCOUNT_CODES,
  DISCOUNT_CODE,
  RESOLVE_PROCESS_DISCOUNT_CODE,
};

export default discountCodes;
